<script lang="ts">
	import { type Snippet, onMount } from "svelte";
	import type { ClassValue } from "svelte/elements";
	import type { Media } from "@core/schema/Media.js";
	import { getUploadedFilePath } from "@core/utils/getUploadedFilePath.js";
	import { refreshAndInitializeLightbox } from "@core/utils/refreshAndInitializeLightbox.js";
	import { thumbUploadedFile } from "@core/utils/thumbUploadedFile.js";
	import { getGlobalSettings } from "../../contexts/getGlobalSettings.js";

	const all: {
		caption?: string;
		class?: ClassValue;
		id?: string;
		type: "image" | "video" | "youtube";
		children?: Snippet;
		source: { href: string } | { media: Media; width: number };
	} = $props();

	onMount(() => {
		void refreshAndInitializeLightbox();
	});

	function update(_value: typeof all.source): void {
		if (typeof window !== "undefined") {
			void refreshAndInitializeLightbox();
		}
	}

	const { FILE_BUCKET_URL_MAP } = getGlobalSettings();

	$effect(() => {
		update(all.source);
	});

	const href = $derived.by<string>(() => {
		if ("href" in all.source) {
			return all.source.href;
		} else {
			if (all.source.media.type.startsWith("video")) {
				return getUploadedFilePath(all.source.media, FILE_BUCKET_URL_MAP);
			} else {
				return thumbUploadedFile(all.source.width, 0, all.source.media, FILE_BUCKET_URL_MAP);
			}
		}
	});
</script>

<a {href} class={all.class} data-fslightbox={all.id ?? ""} data-type={all.type} data-caption={all.caption}>
	{@render all.children?.()}
</a>
